import {RootState} from '../../store';
import {ProviderMapping} from './types';

export const selectionSelector = (state: RootState): Record<string, ProviderMapping> =>
    state['provider-mappings'].selection as Record<string, ProviderMapping>;
